export default __webpack_public_path__ + "cc8c34a18f07b3f2118e37c4ea438fb3.svg";